import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import StockProductFontList from '../entities/front-stockproduct'
import appconst from '@/lib/appconst';
import PublicStockEdit from '../entities/back-public-stock-edit'

interface PublicStockProductState extends ListState<StockProductFontList> {
    stockproductmodel: StockProductFontList,

}

class PublicStockMutations extends ListMutations<StockProductFontList>{

}
class PublicStockProduct extends ListModule<PublicStockProductState, any, StockProductFontList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<StockProductFontList>(),
        loading: false,
        stockproductmodel: StockProductFontList,
        id: 0,
        sku: '',
        safeStockNum: null,
        purchaseCost: null,
        publicStockEdit:null,
    }
    actions = {
        async getAll(context: ActionContext<PublicStockProductState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/PublicStockProduct/GetStockProductList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<StockProductFontList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;

        },
        async edit(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/PublicStockProduct/EditStockProduct', payload.data);
        },
        async updateStockProductDisable(state: any, payload: any) {
            let rep = await Ajax.get('/api/services/app/PublicStockProduct/UpdateStockProductDisable?stockId=' + payload.data.stockId);
        },
    };
    mutations = {
        setCurrentPage(state: PublicStockProductState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PublicStockProductState, pagesize: number) {
            state.pageSize = pagesize;
        },
    }
}

const publicstockproduct = new PublicStockProduct();
export default publicstockproduct;